import { render, staticRenderFns } from "./CompactLegendView.vue?vue&type=template&id=1eb49320&"
import script from "./CompactLegendView.vue?vue&type=script&lang=js&"
export * from "./CompactLegendView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports